import KeyReplace from './KeyReplace';

export default KeyReplace;